import type { AustralianState } from '@/data/courses/courses';

/**
 * Single source of truth for which Australian states each course family is
 * offered in. Every state-aware course list (footer, mega menu, programme
 * catalogue) must derive visibility from this mapping so the lists can never
 * diverge.
 */
export type CourseFamily =
  | 'oc'
  | 'selective_nsw'
  | 'selective_vic'
  | 'scholarship_vic'
  | 'gate'
  | 'naplan';

export const ALL_AUSTRALIAN_STATES: AustralianState[] = [
  'NSW',
  'VIC',
  'QLD',
  'WA',
  'SA',
  'NT',
  'TAS',
  'ACT',
];

export const COURSE_FAMILY_STATES: Record<CourseFamily, AustralianState[]> = {
  oc: ['NSW'],
  selective_nsw: ['NSW'],
  selective_vic: ['VIC'],
  scholarship_vic: ['VIC'],
  gate: ['WA'],
  naplan: ALL_AUSTRALIAN_STATES,
};

export const isCourseFamilyAvailableIn = (
  family: CourseFamily,
  state: string | null | undefined,
): boolean =>
  !!state &&
  COURSE_FAMILY_STATES[family].includes(state.toUpperCase() as AustralianState);

/**
 * Helper for families that have two catalogue entries (one per pricing slug).
 * The state-specific variant owns its own state, the general variant covers
 * every other state the family is offered in.
 */
export const familyStatesExcluding = (
  family: CourseFamily,
  excluded: AustralianState[],
): AustralianState[] =>
  COURSE_FAMILY_STATES[family].filter((state) => !excluded.includes(state));
